import React from "react";
import Button from "react-bootstrap/Button";

const MonthlyMemberPlan = (props) => {
  const {
    userDetails,
    handleUpgrade,
    upgradeUserToFreePlan,
    handleDowngrade,
    ContactModalShow,
  } = props;
  return (
    <>
      <div class="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 class="d-flex align-items-center plan-color-blue">
          Member{" "}
          {/* <span className="sparkle-span align-top">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.6625 13.5232C19.6644 13.829 19.5715 14.1279 19.3966 14.3787C19.2216 14.6295 18.9732 14.82 18.6856 14.9238L13.8434 16.7051L12.0622 21.5435C11.9567 21.8301 11.7659 22.0774 11.5154 22.2521C11.2649 22.4268 10.9669 22.5204 10.6616 22.5204C10.3562 22.5204 10.0582 22.4268 9.80773 22.2521C9.55727 22.0774 9.36642 21.8301 9.26094 21.5435L7.475 16.7107L2.63563 14.9294C2.34906 14.824 2.10175 14.6331 1.92705 14.3827C1.75236 14.1322 1.65869 13.8342 1.65869 13.5288C1.65869 13.2235 1.75236 12.9254 1.92705 12.675C2.10175 12.4245 2.34906 12.2337 2.63563 12.1282L7.47782 10.3469L9.25907 5.50851C9.36455 5.22194 9.5554 4.97462 9.80585 4.79993C10.0563 4.62524 10.3543 4.53157 10.6597 4.53157C10.9651 4.53157 11.2631 4.62524 11.5135 4.79993C11.764 4.97462 11.9548 5.22194 12.0603 5.50851L13.8416 10.3507L18.68 12.1319C18.9672 12.2343 19.2157 12.423 19.3916 12.672C19.5674 12.921 19.6621 13.2183 19.6625 13.5232ZM14.4125 4.52319H15.9125V6.02319C15.9125 6.22211 15.9915 6.41287 16.1322 6.55352C16.2728 6.69418 16.4636 6.77319 16.6625 6.77319C16.8614 6.77319 17.0522 6.69418 17.1928 6.55352C17.3335 6.41287 17.4125 6.22211 17.4125 6.02319V4.52319H18.9125C19.1114 4.52319 19.3022 4.44418 19.4428 4.30352C19.5835 4.16287 19.6625 3.97211 19.6625 3.77319C19.6625 3.57428 19.5835 3.38352 19.4428 3.24286C19.3022 3.10221 19.1114 3.02319 18.9125 3.02319H17.4125V1.52319C17.4125 1.32428 17.3335 1.13352 17.1928 0.992863C17.0522 0.852211 16.8614 0.773193 16.6625 0.773193C16.4636 0.773193 16.2728 0.852211 16.1322 0.992863C15.9915 1.13352 15.9125 1.32428 15.9125 1.52319V3.02319H14.4125C14.2136 3.02319 14.0228 3.10221 13.8822 3.24286C13.7415 3.38352 13.6625 3.57428 13.6625 3.77319C13.6625 3.97211 13.7415 4.16287 13.8822 4.30352C14.0228 4.44418 14.2136 4.52319 14.4125 4.52319ZM22.6625 7.52319H21.9125V6.77319C21.9125 6.57428 21.8335 6.38352 21.6928 6.24286C21.5522 6.10221 21.3614 6.02319 21.1625 6.02319C20.9636 6.02319 20.7728 6.10221 20.6322 6.24286C20.4915 6.38352 20.4125 6.57428 20.4125 6.77319V7.52319H19.6625C19.4636 7.52319 19.2728 7.60221 19.1322 7.74286C18.9915 7.88352 18.9125 8.07428 18.9125 8.27319C18.9125 8.47211 18.9915 8.66287 19.1322 8.80352C19.2728 8.94418 19.4636 9.02319 19.6625 9.02319H20.4125V9.77319C20.4125 9.97211 20.4915 10.1629 20.6322 10.3035C20.7728 10.4442 20.9636 10.5232 21.1625 10.5232C21.3614 10.5232 21.5522 10.4442 21.6928 10.3035C21.8335 10.1629 21.9125 9.97211 21.9125 9.77319V9.02319H22.6625C22.8614 9.02319 23.0522 8.94418 23.1928 8.80352C23.3335 8.66287 23.4125 8.47211 23.4125 8.27319C23.4125 8.07428 23.3335 7.88352 23.1928 7.74286C23.0522 7.60221 22.8614 7.52319 22.6625 7.52319Z"
                fill="#66B927"
              />
            </svg>
          </span> */}
        </h4>
        <p class="pb-20 plan-color-blue">
        Unlock features to get the most out of Gitcha for less. 
        </p>
        <p class="short-para-blue">
          $13/month<span>Billed monthly</span>
        </p>
        <div class="btn-sec btn-sec-btmbrder-blue">
          {userDetails?.PlanName == null ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              onClick={() => handleUpgrade(2, "Member")}
            >
              Select
            </Button>
          ) : (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              disabled={
                userDetails?.PlanName === "Member" && userDetails?.period === 2
              }
              onClick={() => handleUpgrade(2, "Member")}
            >
              {userDetails?.PlanName === "Member" && userDetails?.period === 2
                ? "Your Current Plan"
                : userDetails?.PlanName === "Investor Member" ? "Downgrade" : "Upgrade"}
            </Button>
          )}
        </div>
        <ul class="plan-features-list plan-color-blue">
          
          <li className="plan-features-listbg-blue">Unlimited want-ads</li>
          <li className="plan-features-listbg-blue">
            Unlimited properties in your inventory
          </li>
          <li className="plan-features-listbg-blue">
            10 free introductions per month
          </li>
        </ul>
      </div>

      <div class="mob-plan-wraper w-100 plan-bg-blue mb-20">
        {/* {(userDetails?.PlanName === "Free" ||
          userDetails?.PlanName == null) && (
          <span className="table-badge-green">Best value</span>
        )} */}
        <h4 class="d-flex align-items-center plan-color-blue">
          Investor
          {/* <span className="sparkle-span align-top">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.6625 13.5232C19.6644 13.829 19.5715 14.1279 19.3966 14.3787C19.2216 14.6295 18.9732 14.82 18.6856 14.9238L13.8434 16.7051L12.0622 21.5435C11.9567 21.8301 11.7659 22.0774 11.5154 22.2521C11.2649 22.4268 10.9669 22.5204 10.6616 22.5204C10.3562 22.5204 10.0582 22.4268 9.80773 22.2521C9.55727 22.0774 9.36642 21.8301 9.26094 21.5435L7.475 16.7107L2.63563 14.9294C2.34906 14.824 2.10175 14.6331 1.92705 14.3827C1.75236 14.1322 1.65869 13.8342 1.65869 13.5288C1.65869 13.2235 1.75236 12.9254 1.92705 12.675C2.10175 12.4245 2.34906 12.2337 2.63563 12.1282L7.47782 10.3469L9.25907 5.50851C9.36455 5.22194 9.5554 4.97462 9.80585 4.79993C10.0563 4.62524 10.3543 4.53157 10.6597 4.53157C10.9651 4.53157 11.2631 4.62524 11.5135 4.79993C11.764 4.97462 11.9548 5.22194 12.0603 5.50851L13.8416 10.3507L18.68 12.1319C18.9672 12.2343 19.2157 12.423 19.3916 12.672C19.5674 12.921 19.6621 13.2183 19.6625 13.5232ZM14.4125 4.52319H15.9125V6.02319C15.9125 6.22211 15.9915 6.41287 16.1322 6.55352C16.2728 6.69418 16.4636 6.77319 16.6625 6.77319C16.8614 6.77319 17.0522 6.69418 17.1928 6.55352C17.3335 6.41287 17.4125 6.22211 17.4125 6.02319V4.52319H18.9125C19.1114 4.52319 19.3022 4.44418 19.4428 4.30352C19.5835 4.16287 19.6625 3.97211 19.6625 3.77319C19.6625 3.57428 19.5835 3.38352 19.4428 3.24286C19.3022 3.10221 19.1114 3.02319 18.9125 3.02319H17.4125V1.52319C17.4125 1.32428 17.3335 1.13352 17.1928 0.992863C17.0522 0.852211 16.8614 0.773193 16.6625 0.773193C16.4636 0.773193 16.2728 0.852211 16.1322 0.992863C15.9915 1.13352 15.9125 1.32428 15.9125 1.52319V3.02319H14.4125C14.2136 3.02319 14.0228 3.10221 13.8822 3.24286C13.7415 3.38352 13.6625 3.57428 13.6625 3.77319C13.6625 3.97211 13.7415 4.16287 13.8822 4.30352C14.0228 4.44418 14.2136 4.52319 14.4125 4.52319ZM22.6625 7.52319H21.9125V6.77319C21.9125 6.57428 21.8335 6.38352 21.6928 6.24286C21.5522 6.10221 21.3614 6.02319 21.1625 6.02319C20.9636 6.02319 20.7728 6.10221 20.6322 6.24286C20.4915 6.38352 20.4125 6.57428 20.4125 6.77319V7.52319H19.6625C19.4636 7.52319 19.2728 7.60221 19.1322 7.74286C18.9915 7.88352 18.9125 8.07428 18.9125 8.27319C18.9125 8.47211 18.9915 8.66287 19.1322 8.80352C19.2728 8.94418 19.4636 9.02319 19.6625 9.02319H20.4125V9.77319C20.4125 9.97211 20.4915 10.1629 20.6322 10.3035C20.7728 10.4442 20.9636 10.5232 21.1625 10.5232C21.3614 10.5232 21.5522 10.4442 21.6928 10.3035C21.8335 10.1629 21.9125 9.97211 21.9125 9.77319V9.02319H22.6625C22.8614 9.02319 23.0522 8.94418 23.1928 8.80352C23.3335 8.66287 23.4125 8.47211 23.4125 8.27319C23.4125 8.07428 23.3335 7.88352 23.1928 7.74286C23.0522 7.60221 22.8614 7.52319 22.6625 7.52319Z"
                fill="#66B927"
              />
            </svg>
          </span> */}
        </h4>
        <p class="pb-20 plan-color-blue">
        Includes investor specific features to create more opportunities.
        </p>
        <p class="short-para-blue">
        {/* Coming soon */}
          $15/month<span>Billed annually</span>
        </p>
        <div class="btn-sec btn-sec-btmbrder-blue">
          {userDetails?.PlanName == null ? (
            <Button
              // disabled
              variant="primary"
              className="plan-btn btn btn-primary"
              onClick={() => handleUpgrade(2, "Investor Member")}
            >
              {" "}
              Select
            </Button>
          ) : (
            <Button
              variant="primary"
              className="plan-btn btn btn-primary"
              // disabled
              disabled={
                userDetails?.PlanName === "Investor Member" && userDetails?.period === 2
              }
              onClick={() => handleUpgrade(2, "Investor Member")}
            >
              {userDetails?.PlanName === "Investor Member" && userDetails?.period === 2
                ? "Current Plan"
                : "Upgrade"}
            </Button>
          )}
        </div>
        {/* <ul class="plan-features-list plan-color-blue plan-feature-blur">    */}
        <ul class="plan-features-list plan-color-blue">        
          <li className="plan-features-listbg-blue">Property management dashboard </li>
          <li className="plan-features-listbg-blue">
          Additional buyer box criteria
          </li>
          <li className="plan-features-listbg-blue">
          Unlimited want-ads
          </li>
          <li className="plan-features-listbg-blue">Unlimited properties in your inventory </li>
          <li className="plan-features-listbg-blue">
          10 free introductions per month
          </li>
          <li className="plan-features-listbg-blue">
          Custom Investor profile and badge
          </li>
        </ul>
      </div>

      <div class="mob-plan-wraper w-100 plan-bg-white plan-brdr-grey mb-20">
        <h4 class="d-flex align-items-center plan-color-black">Lite</h4>
        <p class="pb-20">
        Get a taste of what Gitcha can do with limited features.
        </p>
        <p class="short-para-black">Free</p>
        <div class="btn-sec btn-sec-btmbrder-grey">
          {userDetails?.PlanName == null ? (
            <Button
              variant="primary"
              onClick={() => upgradeUserToFreePlan()}
              className="plan-btn btn btn-primary"
            >
              Select
            </Button>
          ) : userDetails?.PlanName === "Lite" ? (
            <Button
              variant="primary"
              className="plan-btn btn btn-secondary-blue"
              disabled
            >
              Current plan
            </Button>
          ) : (
            <Button
              variant="outline"
              className="btn-outline-primary plan-btn downgrade-btn"
              onClick={() => handleDowngrade()}
             
            >
              Downgrade
            </Button>
          )}
        </div>
        <ul class="plan-features-list plan-features-listtext-black">
          <li className="plan-features-listbg-black">Pay per introduction</li>
          <li className="plan-features-listbg-black">
            Up to 2 properties in your inventory
          </li>
          <li className="plan-features-listbg-black">Unlimited want-ads</li>
        </ul>
      </div>
      <div class="mob-plan-wraper w-100 plan-bg-blue mb-20">
        <h4 class="d-flex align-items-center plan-color-blue">Enterprise</h4>
        <p class="pb-20 plan-color-blue">
        Want more seats for your company or team? 
        </p>
        <p class="short-para-blue">Tiered pricing/seat</p>
        <div class="btn-sec btn-sec-btmbrder-blue">
          <Button
            variant="primary"
            className="plan-btn btn btn-primary"
            // onClick={()=>sendEmailSales("")}
            onClick={() => {
              ContactModalShow();
            }}
          >
            Contact us
          </Button>
        </div>        
      </div>
    </>
  );
};

export default MonthlyMemberPlan;
